module.exports = __webpack_public_path__ + "img/logo-web-white.1f7c8c4b.svg";